import { TX } from '../registry/keys';

/** Cosmetic hats the player can wear. Stored globally (localStorage), not per-save. */
export interface HatDef {
  id: string;
  name: string;
  tex?: string; // undefined = no hat
}

export const HATS: HatDef[] = [
  { id: 'none', name: 'No Hat' },
  { id: 'straw', name: 'Straw Hat', tex: TX.hatStraw },
  { id: 'bow', name: 'Hair Bow', tex: TX.hatBow },
  { id: 'party', name: 'Party Hat', tex: TX.hatParty },
  { id: 'crown', name: 'Crown', tex: TX.hatCrown },
];

const KEY = 'sandyhollow.hat';

export function getHat(): string {
  try {
    return localStorage.getItem(KEY) ?? 'none';
  } catch {
    return 'none';
  }
}

export function setHat(id: string): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* ignore */
  }
}

export function hatTexture(id: string): string | undefined {
  return HATS.find((h) => h.id === id)?.tex;
}

/** Clara's outfits — unlocked by friendship hearts. Stored globally. */
export interface ClaraOutfit {
  id: string;
  name: string;
  tex?: string;
  unlock: number; // hearts needed
}
export const CLARA_OUTFITS: ClaraOutfit[] = [
  { id: 'none', name: 'None', unlock: 0 },
  { id: 'bow', name: 'Bow', tex: TX.hatBow, unlock: 3 },
  { id: 'straw', name: 'Sun Hat', tex: TX.hatStraw, unlock: 8 },
  { id: 'crown', name: 'Crown', tex: TX.hatCrown, unlock: 15 },
];

const CKEY = 'sandyhollow.claraoutfit';
export function getClaraOutfit(): string {
  try {
    return localStorage.getItem(CKEY) ?? 'none';
  } catch {
    return 'none';
  }
}
export function setClaraOutfit(id: string): void {
  try {
    localStorage.setItem(CKEY, id);
  } catch {
    /* ignore */
  }
}
export function claraOutfitTexture(id: string): string | undefined {
  return CLARA_OUTFITS.find((o) => o.id === id)?.tex;
}

/** Pet collar colors — purely cosmetic, stored globally. */
export interface Collar {
  id: string;
  name: string;
  color?: number;
}
export const COLLARS: Collar[] = [
  { id: 'none', name: 'None' },
  { id: 'red', name: 'Red', color: 0xd0584a },
  { id: 'blue', name: 'Blue', color: 0x5a8fd0 },
  { id: 'green', name: 'Green', color: 0x5aae54 },
  { id: 'pink', name: 'Pink', color: 0xe06d8b },
];
const COLLAR_KEY = 'sandyhollow.collar';
export function getCollar(): string {
  try {
    return localStorage.getItem(COLLAR_KEY) ?? 'none';
  } catch {
    return 'none';
  }
}
export function setCollar(id: string): void {
  try {
    localStorage.setItem(COLLAR_KEY, id);
  } catch {
    /* ignore */
  }
}
export function collarColor(id: string): number | undefined {
  return COLLARS.find((c) => c.id === id)?.color;
}
